import { render, staticRenderFns } from "./LogisticHeadDashboard.vue?vue&type=template&id=760288f2&scoped=true&"
import script from "./LogisticHeadDashboard.vue?vue&type=script&lang=js&"
export * from "./LogisticHeadDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LogisticHeadDashboard.vue?vue&type=style&index=0&id=760288f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760288f2",
  null
  
)

export default component.exports